module.exports = __webpack_public_path__ + "img/blueLoGo2@2x.7259fcfa.png";